import { faSliders } from '@fortawesome/pro-regular-svg-icons';

import { PATH } from '@constants';

import { Icon, Link } from '@components';

export const AdminSectionPanelPlatform = () => {
  return (
    <div className="mt-2 w-full">
      <p className="mb-4 px-2 text-caption uppercase text-neural-04">Admin</p>

      <Link
        variant="ghost"
        to={PATH.ADMIN_SECTION_USERS}
        className="w-full justify-start px-2 font-400"
      >
        <Icon icon={faSliders} className="mr-2 text-xl" />
        Administration
      </Link>

      <div className="my-6 h-px w-full bg-neural-01 " />
    </div>
  );
};
